/* eslint-disable react/require-default-props */
import React from 'react';

export type SkeletonLoaderProps = {
  className?: string,
};

const SkeletonLoader = ({ className }: SkeletonLoaderProps) => (
  <div className={`animate-pulse rounded-full bg-kat-nordic/40 ${className ? `${className}` : 'h-4 w-full'}`} />
);

export default SkeletonLoader;
